import './HomePage.css';
import React from 'react';
import "@fontsource/quicksand";
import { Outlet } from "react-router-dom";
import Header from './components/Header';
import Footer from './components/Footer';




class HomePage extends React.Component {
  // constructor(props) {
  //   super(props);
  //   // this.state = {
  //   //   isLoading: true,
  //   // }
  // }

  render() {

    return (
      <React.Fragment >
        <div className='div-firstpage' >
          {/* <ClipLoader color={'silver'} size={150} loading={this.state.isLoading} cssOverride={override}/> */}
          
          <Header />
          <Outlet />
          <Footer />
        </div>
      </React.Fragment>
    )
  }
}

export default HomePage;
